import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./components/home";
import Menu from "./components/menu";
import Login from "./components/login";
import PostageDataCollection from "./components/PostageDataCollection";
import OrderAddressManagement from "./components/orderaddress";
import AccessDenied from "./components/AccessDenied";
import ProtectedRoute from "./components/ProtectedRoute";
import VeevaReconcileApp from "./features/veevaReconcile/VeevaReconcileApp";
import CustomFulfillment from "./components/CustomFulfillment";
function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

function AppContent() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="home-image">
      <main role="main" className="main">
        {!isLoginPage && <Header onMenuClick={toggleMenu} />}
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/accessDenied" element={<AccessDenied />} />
          <Route path="/" element={<RootRedirect />} />

          {/* 2. Wrap protected routes */}
          {/* <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/postageDataCollection"
            element={
              <ProtectedRoute>
                <PostageDataCollection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/veevaReconcile/*"
            element={<VeevaReconcileApp />}
          />
          <Route
            path="/orderaddress"
            element={
              <ProtectedRoute>
                <OrderAddressManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customFulfillment"
            element={
              <ProtectedRoute>
                <CustomFulfillment />
              </ProtectedRoute>
            }
          />
        </Routes>
        {/* <Route
            path="/orderaddress"
            element={
              <ProtectedRoute>
                <OrderAddressManagement />
              </ProtectedRoute>
            }
          /> */}
      </main>
      {!isLoginPage && <Menu isOpen={isMenuOpen} onMenuClick={toggleMenu} />}
      {!isLoginPage && <Footer />}
    </div>
  );
}

function RootRedirect() {
  const location = useLocation();
  return <Navigate to={`/login${location.search}`} replace />;
}

export default App;
